// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// ── Public ───────────────────────────────────────────────────────────────────

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import CarController from "./car_controller"
application.register("car", CarController)

// ── Admin ────────────────────────────────────────────────────────────────────

import Admin__SortableController from "./admin/sortable_controller"
application.register("admin--sortable", Admin__SortableController)

// ── Shared ───────────────────────────────────────────────────────────────────

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)
